var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1744_14551)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1744_14551)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 0.880859C2.78072 0.880859 2.33301 1.32857 2.33301 1.88086V27.8809C2.33301 28.4331 2.78072 28.8809 3.33301 28.8809H24.6663C25.2186 28.8809 25.6663 28.4331 25.6663 27.8809V5.54753L20.9997 0.880859H3.33301Z",
    fill: "#E9F0FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9995 0.880859V5.54753H25.6662L20.9995 0.880859Z",
    fill: "#C2CDDE"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.1665,
    y: 12.5476,
    width: 25.6667,
    height: 11.6667,
    rx: 1,
    fill: "#34A770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82955 15.5627L9.1108 17.6934H9.15625L10.4432 15.5627H11.6449L9.85227 18.4718L11.6733 21.3809H10.4517L9.15625 19.2644H9.1108L7.81534 21.3809H6.59943L8.4375 18.4718L6.62216 15.5627H7.82955ZM12.4723 21.3809V15.5627H13.5263V20.4973H16.0888V21.3809H12.4723ZM20.1655 17.1621C20.139 16.914 20.0272 16.7208 19.8303 16.5826C19.6352 16.4443 19.3814 16.3752 19.0689 16.3752C18.8492 16.3752 18.6607 16.4083 18.5036 16.4746C18.3464 16.5409 18.2261 16.6309 18.1428 16.7445C18.0594 16.8581 18.0168 16.9879 18.0149 17.1337C18.0149 17.2549 18.0424 17.36 18.0973 17.449C18.1541 17.5381 18.2308 17.6138 18.3274 17.6763C18.424 17.7369 18.531 17.7881 18.6484 17.8297C18.7659 17.8714 18.8842 17.9064 19.0036 17.9348L19.549 18.0712C19.7687 18.1223 19.9799 18.1915 20.1825 18.2786C20.3871 18.3657 20.5698 18.4756 20.7308 18.6081C20.8937 18.7407 21.0225 18.9007 21.1172 19.0882C21.2119 19.2757 21.2592 19.4954 21.2592 19.7473C21.2592 20.0882 21.1721 20.3884 20.9979 20.6479C20.8236 20.9055 20.5717 21.1072 20.2422 21.253C19.9145 21.397 19.5178 21.4689 19.0518 21.4689C18.5992 21.4689 18.2062 21.3989 17.8729 21.2587C17.5414 21.1185 17.282 20.914 17.0945 20.6451C16.9089 20.3761 16.8085 20.0485 16.7933 19.6621H17.8303C17.8454 19.8648 17.9079 20.0333 18.0178 20.1678C18.1276 20.3023 18.2706 20.4026 18.4467 20.4689C18.6248 20.5352 18.8236 20.5684 19.0433 20.5684C19.2725 20.5684 19.4732 20.5343 19.6456 20.4661C19.8198 20.396 19.9562 20.2994 20.0547 20.1763C20.1532 20.0513 20.2034 19.9055 20.2053 19.7388C20.2034 19.5873 20.1589 19.4623 20.0717 19.3638C19.9846 19.2634 19.8625 19.1801 19.7053 19.1138C19.55 19.0456 19.3681 18.985 19.1598 18.932L18.4979 18.7615C18.0187 18.6384 17.6399 18.4519 17.3615 18.2019C17.085 17.95 16.9467 17.6157 16.9467 17.199C16.9467 16.8562 17.0395 16.556 17.2251 16.2985C17.4126 16.0409 17.6674 15.8411 17.9893 15.699C18.3113 15.5551 18.6759 15.4831 19.0831 15.4831C19.496 15.4831 19.8577 15.5551 20.1683 15.699C20.4808 15.8411 20.7261 16.039 20.9041 16.2928C21.0821 16.5447 21.174 16.8345 21.1797 17.1621H20.1655Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1744_14551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.880859)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1744_14551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3333,
    height: 28,
    fill: "white",
    transform: "translate(2.33301 0.880859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls01);
export default __webpack_public_path__ + "static/media/XLS_01.a1331d0ae4ff99e84655615b28e38e23.svg";
export { ForwardRef as ReactComponent };